<template>
  <div class="collection-slider-wrapper-phone">
    <div class="slider-header text-center">
      <h2 class="merriweather-reg-20">Des séjours pensés</h2>
      <h2 class="merriweather-reg-28">Pour chaque envie</h2>
      <p class="merriweather-light-18">Des collections exclusives où chaque séjour est un <span class="merriweather-light-italic-18">privilège</span></p>
    </div>
    <div class="collection-border-bottom">
      <div class="row collection-border"></div>
    </div>
    <div class="slider-container position-relative" data-aos="fade-up" data-aos-duration="900"> 
      <template v-for="(collection, index) in collectionsMounted">
        <div class="collection-card">
          <div class="card-hub" @click="goToCollection(getCollectionUrl(collection.slug))">
            <img v-if="collection.photo_key" :src="collection.photo_key" class="img-collection" :alt="collection.name">
            <img v-else src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg" class="img-collection" :alt="collection.name">
            <p class="merriweather-italic-24">{{ collection.name }}</p>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center text-center pt-3">
            <span class="subtitle-card raleway-bold-p">{{ collection.title }}</span>
            <a :href="getCollectionUrl(collection.slug)" target="_blank" class="link-hortense">Découvrir la collection</a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
  import AOS from 'aos';
  import CardCollection from 'components/cards/CardCollection.vue';
  export default {
    name: 'CollectionHome',
    components: { CardCollection },
    props: {
      collections: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        value: 4,
      }
    },
    methods: {
      goToCollection(url) {
        window.open(url, '_blank');
      },
      getCollectionUrl(slug) {
        if (slug && slug.startsWith('vacances-')) {
          return '/' + slug;
        }
        return '/collections/' + slug;
      }
    },
    computed: {
      collectionsMounted() {
        const collections = [...this.collections];

        // Extract Séraphine
        const seraphineIndex = collections.findIndex(c => c.name.trim() === 'Séraphine');
        let seraphine = null;

        if (seraphineIndex !== -1) {
          seraphine = collections.splice(seraphineIndex, 1)[0];
        }

        const vacations = [
          {
            name: "Vacances d'été",
            title: "Sous le soleil",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-ete.webp",
            slug: "vacances-ete"
          },
          {
            name: "Vacances de printemps",
            title: "Réveil de la Nature",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-printemps.webp",
            slug: "vacances-printemps"
          },
          {
            name: "Vacances de Noël",
            title: "Au coeur des fêtes",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-noel.webp",
            slug: "vacances-noel"
          },
          {
            name: "Vacances d'hiver",
            title: "Charme hivernal",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-hiver.webp",
            slug: "vacances-hiver"
          },
          {
            name: "Vacances de la Toussaint",
            title: "Couleurs d'automne",
            photo_key: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Offres+exclusives/vacances-toussaint.webp",
            slug: "vacances-toussaint"
          }
        ];

        return seraphine
          ? [...collections, seraphine, ...vacations]
          : [...collections, ...vacations];
      }
    },
    mounted() {
      AOS.init();
    }
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/card-collection'>

.col-weekend{
  padding-left: 40px;
}

.collection-slider-wrapper-phone {
  margin-top: 50px !important;

  background: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-collections.webp');
  background-position: center 58%;
  max-height: 850px;
  padding: 80px 0 80px 0;
  color: white;
  width: 100%;

  .collection-border {
    border-bottom: 1px solid white;
  }
  .collection-border-bottom {
    padding-left: 35px;
    padding-right: 35px; 
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .slider-container {
    max-width: 100% !important;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 30px;
    overflow-x: auto;
    padding: 0 10px 0 10px;
  }

  .img-collection {
    width: 260px;
    height: 330px;
    object-fit: cover;
  }

  .card-hub {
    position: relative;
    width: 100%;
    cursor: pointer;
  }

  .card-hub img {
    width: 260px;
    height: 330px;
    object-fit: cover;
    border-radius: 15px;
  }

  .card-hub p {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    color: white;
  }

  .collection-card {
    .link-hortense {
      color: white;
    }
  }

  .merriweather-reg-40 {
    font-size: 40px !important;
  }

  .zoom-img-container {
    border-radius: 15px;
  }
}
</style>
